import React from "react";
import { useNavigate } from "react-router-dom";
import { useResource } from "../hooks";
import { api, fmtINR, fmtNum } from "../api";
import AskOIM from "../components/AskOIM";

const HEALTH_OF = (leak) => leak > 30000 ? "critical" : leak > 8000 ? "warning" : "healthy";

const UNIT_DEFS = [
  { key: "boiler",        cat: "utility", name: "Boiler",          primary: "efficiency_pct",     unit: "% eff",     bench: "benchmark_eff" },
  { key: "cooling_tower", cat: "utility", name: "Cooling Tower",   primary: "approach_c",         unit: "°C app.",   bench: "benchmark_approach" },
  { key: "chiller",       cat: "utility", name: "Chiller",         primary: "cop",                unit: "COP",       bench: "benchmark_cop" },
  { key: "compressor",    cat: "utility", name: "Air Compressor",  primary: "leak_pct",           unit: "% leak",    bench: "benchmark_leak" },
  { key: "nitration",     cat: "process", name: "Nitration",       primary: "yield_pct",          unit: "% yield",   bench: "benchmark_yield" },
  { key: "hydrogenation", cat: "process", name: "Hydrogenation",   primary: "yield_pct",          unit: "% yield",   bench: "benchmark_yield" },
  { key: "distillation",  cat: "process", name: "Distillation",    primary: "purity_pct",         unit: "% purity",  bench: "benchmark_purity" },
  { key: "solvent",       cat: "process", name: "Solvent Recovery",primary: "recovery_pct",       unit: "% recovery",bench: "benchmark_recovery" },
];

export default function OperationsCenter() {
  const twins = useResource(() => api.twins(), [], 2000);
  const nav = useNavigate();
  if (!twins) return <div className="muted">Loading twin states…</div>;

  const idx = Object.fromEntries((twins.twins || []).map(t => [t.key, t]));

  return (
    <div className="stack" data-testid="operations-center">
      <div className="page-title">
        <div>
          <h1>Operations Center</h1>
          <div className="sub">Plant Digital Twin · Click a unit for deep-dive</div>
        </div>
      </div>

      <div>
        <div className="section-header"><h2>Utility Twins</h2><span className="chip utility">Steam · Power · Cooling · Air</span></div>
        <div className="unit-grid">
          {UNIT_DEFS.filter(u => u.cat === "utility").map(u => <UnitCard key={u.key} def={u} twin={idx[u.key]} onClick={() => nav(`/operations/${u.key}`)} />)}
        </div>
      </div>

      <div>
        <div className="section-header"><h2>Process Twins</h2><span className="chip process">Nitrobenzene → Aniline chain</span></div>
        <div className="unit-grid">
          {UNIT_DEFS.filter(u => u.cat === "process").map(u => <UnitCard key={u.key} def={u} twin={idx[u.key]} onClick={() => nav(`/operations/${u.key}`)} />)}
        </div>
      </div>
    </div>
  );
}

function UnitCard({ def, twin, onClick }) {
  const s = twin?.state || {};
  const leak = s.leakage_inrh || 0;
  const health = HEALTH_OF(leak);
  const val = s[def.primary];
  const bench = s[def.bench];

  return (
    <div className="unit-card" onClick={onClick} data-testid={`unit-card-${def.key}`}>
      <div className="unit-head">
        <div>
          <div className="unit-cat">{def.cat}</div>
          <div className="unit-name">{def.name}</div>
        </div>
        <span className={`status-dot ${health}`} />
      </div>
      <div className="unit-primary">
        {fmtNum(val, def.key === "chiller" ? 2 : 1)}
        <span style={{ fontSize: 11, color: "var(--text-tertiary)", marginLeft: 6, fontWeight: 400 }}>{def.unit}</span>
      </div>
      <div className="unit-bench">vs benchmark {fmtNum(bench, def.key === "chiller" ? 2 : 1)}</div>
      <div className="unit-leakage">
        {leak > 100 ? `Leak ${fmtINR(leak)}/hr` : "On benchmark"}
      </div>
      <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 6 }}>
        <AskOIM question={`Why is the ${def.name} performing this way?`} source={def.key} label="Ask OIM" />
      </div>
    </div>
  );
}
